<template>
  <tbody class="is-editable">
    <tr>
      <td class="c-table__cell--center c-table__cell--middle" colspan="1">
        <div class="c-cell">
          <p class="date">{{ summaryService.summary_date }}</p>
        </div>
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ summaryService.display_count }}
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ summaryService.click_count }}
      </td>
      <td class="c-table__cell--center c-table__cell--middle">
        {{ ctr }}
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    summaryService: Object,
  },
  computed: {
    ctr: function () {
      let ctrString = '0.00%';
      if(this.summaryService.display_count > 0 && this.summaryService.click_count > 0){
        let ctr = this.summaryService.click_count * 100 / this.summaryService.display_count;
        ctrString = ctr.toFixed(2) + '%';
      }
      return ctrString;
    },
  },
};
</script>
